import { useState } from "react";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import Dropdown from "./Dropdown";
import { printCode } from "../devices/godex";
import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../support-extra/css/GodexPrinting.css";
import "../css/GoDexLabelPopup.css";
import { goDexPrintFormatTypes } from "../js/utils";

const DEFAULT_QUANTITY = "1";
const DEFAULT_DESCRIPTION = "PVP";

export default function GoDexLabelPopup({
  product,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
}) {
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY);
  const [selectedFormat, setSelectedFormat] = useState({
    id: "type5",
    text: "DESCRIPTIVO (COLGANTE)",
  });

  const isOfferFormat =
    selectedFormat.id === "type3" || selectedFormat.id === "type6";
  const hasOfferPrice = product.pvpOferta && product.pvpOferta !== "";

  const code = product.codigoOPTIWIN;
  const price = product.pvp;
  const stock = product.stock;
  const description =
    selectedFormat.id === "type1" || selectedFormat.id === "type4"
      ? DEFAULT_DESCRIPTION
      : product.etiquetado;
  const discountedPrice =
    selectedFormat.id === "type7" || selectedFormat.id === "type8"
      ? product.pvpRecomendado
      : product.pvpOferta;

  const handleQuantityBlur = (e) => {
    if (e === "") setQuantity(DEFAULT_QUANTITY);
  };

  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Impresión de etiquetas
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel">
            <div
              className="data-field data-field-tests"
              style={{ alignItems: "center", gap: 20 }}
            >
              {isOfferFormat && !hasOfferPrice && (
                <span>
                  Este producto no tiene PVP Oferta. No es posible imprimir
                  este formato de etiqueta.
                </span>
              )}
              <div className="opt-table-content grid-4" id="goDex-content-grid">
                <div className="cell cell-start-content">Formato</div>
                <div className="cell cell-start-content combined-cells-3">
                  <Dropdown
                    optionList={goDexPrintFormatTypes.filter(
                      (e) => e.labelFormat === 1,
                    )}
                    size={0}
                    op={selectedFormat.id}
                    onChange={(e) => {
                      setSelectedFormat(e);
                    }}
                  ></Dropdown>
                </div>
                <div className="cell cell-start-content">Cantidad</div>
                <div className="cell">
                  <InputData
                    input={quantity}
                    type="type-only-numbers"
                    size={0}
                    onChange={(e) => setQuantity(e)}
                    onBlur={handleQuantityBlur}
                  />
                </div>
                <div className="cell"></div>
                <div className="cell cell-start-content">
                  <ButtonIconH
                    text="Imprimir cantidad"
                    small={true}
                    disabled={isOfferFormat && !hasOfferPrice}
                    onClick={async () => {
                      const error = await printCode(
                        selectedFormat.id,
                        code,
                        description,
                        price,
                        discountedPrice,
                        quantity,
                      );
                      // console.log(
                        // "IMPRIMIENDO CANTIDAD: ",
                        // selectedFormat.id,
                        // code,
                        // description,
                        // price,
                        // discountedPrice,
                        // quantity,
                      // );
                      if (error)
                        createPopupQuestion(
                          error,
                          removePopupQuestion,
                          null,
                          "Entendido",
                        );
                    }}
                  />
                </div>
                <div className="cell cell-start-content">Stock</div>
                <div className="cell">
                  <InputData
                    input={stock}
                    type="type-only-numbers"
                    size={0}
                    inactive={true}
                    onChange={() => {}}
                  />
                </div>
                <div className="cell"></div>
                <div className="cell cell-start-content">
                  <ButtonIconH
                    text="Imprimir stock"
                    small={true}
                    disabled={stock <= 0 || (isOfferFormat && !hasOfferPrice)}
                    onClick={async () => {
                      const error = await printCode(
                        selectedFormat.id,
                        code,
                        description,
                        price,
                        discountedPrice,
                        stock,
                      );
                      // console.log(
                        // "IMPRIMIENDO STOCK: ",
                        // selectedFormat.id,
                        // code,
                        // description,
                        // price,
                        // discountedPrice,
                        // stock,
                      // );
                      if (error)
                        createPopupQuestion(
                          error,
                          removePopupQuestion,
                          null,
                          "Entendido",
                        );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
